import React from 'react';
import { useTranslation } from 'react-i18next';

// Import images from how-we-work folder
import image1 from '../assets/how-we-work/1.jpg';
import image2 from '../assets/how-we-work/2.jpg';
import image3 from '../assets/how-we-work/3.jpg';

interface HowWeWorkProps {
  className?: string;
}

const HowWeWork: React.FC<HowWeWorkProps> = ({ className = '' }) => {
  const { t } = useTranslation();

  return (
    <div className={`how-we-work-section ${className}`}>
      <style>
        {`
          .how-we-work-section {
            width: 100%;
          }

          .how-we-work-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 2rem;
          }

          .work-cards {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 2rem;
          }

          .work-card {
            background: #fff;
            border-radius: 12px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
            overflow: hidden;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .work-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
          }

          .work-image-container {
            width: 100%;
            height: 250px;
            overflow: hidden;
          }

          .work-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
          }

          .work-content {
            padding: 2rem;
          }

          .work-title {
            font-size: 1.4rem;
            font-weight: 600;
            color: #333;
            margin-bottom: 0.5rem;
            position: relative;
          }

          .work-title::after {
            content: '';
            position: absolute;
            bottom: -8px;
            left: 0;
            width: 50px;
            height: 3px;
            background: #f4b942;
            border-radius: 2px;
          }

          .work-description {
            font-size: 0.95rem;
            line-height: 1.6;
            color: #666;
            margin-top: 1.5rem;
          }

          /* Mobile Styles */
          @media (max-width: 992px) {
            .work-cards {
              grid-template-columns: repeat(2, 1fr);
            }
          }

          @media (max-width: 768px) {
            .how-we-work-container {
              padding: 0 1rem;
            }
            
            .work-cards {
              grid-template-columns: 1fr;
              gap: 1.5rem;
            }
            
            .work-content {
              padding: 1.5rem;
            }
            
            .work-title {
              font-size: 1.2rem;
            }
            
            .work-description {
              font-size: 0.9rem;
            }
          }
        `}
      </style>

      <div className="how-we-work-container">
        <div className="work-cards">
          <div className="work-card">
            <div className="work-image-container">
              <img src={image1} alt={t('how_we_work_card1_title') as string} className="work-image" />
            </div>
            <div className="work-content">
              <h3 className="work-title">{t('how_we_work_card1_title')}</h3>
              <p className="work-description">
                {t('how_we_work_card1_description')}
              </p>
            </div>
          </div>

          <div className="work-card">
            <div className="work-image-container">
              <img src={image2} alt={t('how_we_work_card2_title') as string} className="work-image" />
            </div>
            <div className="work-content">
              <h3 className="work-title">{t('how_we_work_card2_title')}</h3>
              <p className="work-description">
                {t('how_we_work_card2_description')}
              </p>
            </div>
          </div>

          <div className="work-card">
            <div className="work-image-container">
              <img src={image3} alt={t('how_we_work_card3_title') as string} className="work-image" />
            </div>
            <div className="work-content">
              <h3 className="work-title">{t('how_we_work_card3_title')}</h3>
              <p className="work-description">
                {t('how_we_work_card3_description')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowWeWork; 